// Definição para o modal de busca de Parceiros da categoria Armazém (PCAT1)
// Utilizada no cadastro de Local de Estoque quando IsEstoqueProprio = false

export const parceiroArmazemSearch = {
  label: 'Fornecedor (Armazém)',
  placeholder: 'Nome ou Documento...',
  titulo: 'Selecionar Fornecedor (Armazém)',
  endpointApi: 'Parceiros',
  idField: 'idParceiro',
  displayField: 'idParceiro',
  descField: 'nomeFantasia',
  tabela: 'Parceiro',

  camposFiltro: [
    { label: 'Nome Fantasia', model: 'busca', tipo: 'text' }
  ],

  colunasGrid: [
    { header: 'ID', dataField: 'idParceiro', width: '8%' },
    { header: 'Nome Fantasia', dataField: 'nomeFantasia', width: '30%' },
    { header: 'Documento', dataField: 'documento', width: '18%' },
    { header: 'Tipo', dataField: 'lstTipoPessoa', width: '12%' },
    { header: 'UF', dataField: 'uf', width: '8%' },
    { header: 'Regime Tributário', dataField: 'lstRegimeTributario', width: '24%' }
  ],

  // Filtro fixo para categoria Armazém (PCAT1)
  filtrosFixos: {
    lstCategoriaParceiro: 'PCAT1'
  }
}
